export default __webpack_public_path__ + "static/media/Princess@2x.41541c14.png";